import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Give the page a tick to render before scrolling to the anchor
      const id = hash.replace('#', '');
      const attempt = (retries = 0) => {
        const el = document.getElementById(id);
        if (el) {
          // Add offset for the fixed header (typically ~72px)
          const y = el.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        } else if (retries < 10) {
          setTimeout(() => attempt(retries + 1), 80);
        }
      };
      // Delay slightly to ensure component layout has occurred
      setTimeout(attempt, 100);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);

  return null;
}